export enum SyncDisabledReason {
  DataProvider = 'data_provider',
  InactiveUser = 'inactive_user',
  UserDisabled = 'user_disabled',
}
